module.exports = __webpack_public_path__ + "img/story010@2x.758812a5.png";